<div *ngIf="lastNotification">
  <app-notification [notification]="lastNotification"
                    [showCloseMark]="true"
                    [loudNotification]="true"
                    (onClose)="removePopup($event)">
  </app-notification>
</div>
